import React from 'react';
import DocumentComposer from '../components/DocumentComposer';

const ChalanPage = () => (
  <DocumentComposer
    pageTitle="Challan PDF"
    documentTitle="CHALLAN"
    numberLabel="Challan No"
    numberField="challanNo"
    numberPlaceholder="e.g. CH-001"
    filePrefix="Challan"
    accentColor="#475569"
    titleBarColor="#334155"
    pdfButtonColor="linear-gradient(135deg, #475569, #64748b)"
    footerNote="This challan is generated electronically and is valid without a signature."
    totalLabel="Total"
    taxLabel="GST"
    showFreightAmountField
  />
);

export default ChalanPage;
